import React, { useState } from "react";
import { Helmet } from "react-helmet";

const Tools = (props) => {
  const title = "Tools";

  return (
    <div className="common-bg-grey">
      <Helmet
        title={title}
        meta={[
          { name: "twitter:card", content: "summary" },
          {
            property: "og:url",
            content:
              "https://sightstones.netlify.app" + props.location.pathname,
          },
          { property: "og:title", content: title },
          {
            property: "og:image",
            content: "https://sightstones.netlify.app/img/ogp.png",
          },
        ]}
      />
      <div className="container bg-white">
        <header>
          <h1 className="my-5 h2 stream-title text-center">{title}</h1>
        </header>
        <div className="row">
          <div className="col-md-8">
            <Converter />
          </div>
          <div className="col-md-4">
            <UpdateButtons />
          </div>
        </div>
      </div>
    </div>
  );
};

const UpdateButtons = () => {
  const [message, setMessage] = useState("none");

  const update = (e) => {
    async function request(slug) {
      setMessage(slug + " => Updating...");
      const res = await fetch(
        "https://script.google.com/macros/s/" +
          process.env.REACT_APP_SHEET_ID +
          "/exec?q=update&slug=" +
          slug
      );
      return res.json();
    }

    const slug = e.target.textContent.toLowerCase();

    request(slug).then((json) => {
      setMessage(slug + " => " + json.message);
    });
  };

  return (
    <div className="update-buttons mb-5">
      <h2 className="mb-4">Update</h2>
      <div className="bg-light p-4 mb-4">Status: {message}</div>
      <button className="d-block mb-4 btn btn-primary" onClick={update}>
        Toplist
      </button>
      <button className="d-block mb-4 btn btn-primary" onClick={update}>
        StreamChecker
      </button>
      <button className="d-block mb-4 btn btn-primary" onClick={update}>
        Matches
      </button>
      <button className="d-block mb-4 btn btn-primary" onClick={update}>
        Twitter
      </button>
    </div>
  );
};

const Converter = () => {
  async function request(name) {
    const res = await fetch("/.netlify/functions/puuid?name=" + name);
    return res.text();
  }

  const convert = () => {
    const input = document.getElementById("converter-input").value;
    const names = input
      .split("\n")
      .map((line) => line.replace(/\s/g, ""))
      .filter((line) => line !== "");

    const output = document.getElementById("converter-output");
    names.map((name) => {
      request(name).then((converted_id) => {
        output.value = output.value + converted_id + "\n";
      });
      return false;
    });
  };

  return (
    <div className="converter mb-5">
      <h2 className="mb-4">Converter</h2>
      <p>
        Convert summoner name to puuid that is encrypted with the site&apos;s
        api key.
      </p>
      <h5>Input</h5>
      <p>
        <textarea id="converter-input" className="form-control" rows="5" />
      </p>
      <h5>Output</h5>
      <p>
        <textarea
          id="converter-output"
          className="form-control"
          rows="5"
          readOnly
        />
      </p>
      <p>
        <button className="btn btn-success" onClick={convert}>
          Run
        </button>
      </p>
    </div>
  );
};

export default Tools;
